import React from 'react';
import { Group } from '@landr/maestro';
import { Included } from '../types';
import IncludedItem from './IncludedItem';

const IncludedGroup = ({
    items,
    isLoading,
    isMobile,
}: {
    items: Included[];
    isLoading: boolean;
    isMobile: boolean;
}) => {
    return (
        <Group direction="vertical" my="jb">
            {items.map((item) => (
                <Group.Item key={item.copy}>
                    <IncludedItem
                        item={item}
                        isLoading={isLoading}
                        isMobile={isMobile}
                    />
                </Group.Item>
            ))}
        </Group>
    );
};

export default IncludedGroup;
